module.exports = __webpack_public_path__ + "img/048-pirate.f4ead6f5.png";